import { render, staticRenderFns } from "./Opening.vue?vue&type=template&id=82c2f080&scoped=true&"
import script from "./Opening.vue?vue&type=script&lang=js&"
export * from "./Opening.vue?vue&type=script&lang=js&"
import style0 from "./Opening.vue?vue&type=style&index=0&id=82c2f080&lang=scss&scoped=true&"
import style1 from "./Opening.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c2f080",
  null
  
)

export default component.exports